// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"48bd7ba0","292":"a4a7a47e","372":"19374aeb","434":"f800c460","676":"c863a868"}[chunkId] + ".chunk.css";
};